import { render, staticRenderFns } from "./PersonCommonPrescriptions.vue?vue&type=template&id=4edbe9fd&scoped=true"
import script from "./PersonCommonPrescriptions.vue?vue&type=script&lang=js"
export * from "./PersonCommonPrescriptions.vue?vue&type=script&lang=js"
import style0 from "./PersonCommonPrescriptions.vue?vue&type=style&index=0&id=4edbe9fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edbe9fd",
  null
  
)

export default component.exports